export const DEFAULT_CRM_TOKEN = 'do0p2poophp';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['25'];
export const faqArticleIds = ['3', '5', '6', '8', '9', '10', '11', '17', '18', '20', '23', '24'];
